"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function copyToClipboard(str) {
    var el = document.createElement('textarea');
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
}
exports.copyToClipboard = copyToClipboard;
//# sourceMappingURL=clipboard.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/utils/clipboard.js
// module id = 677
// module chunks = 1